// deploy-sync touch
// src/main.jsx
// Phase A2: Service worker registration added for PWA support
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import AdminApp from './AdminApp'
import './theme/theme.css'
import { initTheme } from './theme/theme'

// Sync theme state (data-theme is already set by the inline script in index.html)
initTheme()

// admin.kailux.co.za gets a completely separate, minimal app (login +
// Admin Board only) — never the client app's routes. Kept as a runtime
// hostname check (rather than a separate Vercel build) so both domains can
// point at the same deployment. Local/dev hosts (localhost, Vercel preview
// URLs, etc.) always get the normal client app.
const isAdminHost = window.location.hostname.startsWith('admin.')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isAdminHost ? <AdminApp /> : <App />}
  </React.StrictMode>
)

// ── Phase A2: Register Service Worker ────────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        console.log('[KaiLux] Service worker registered:', registration.scope)

        // Check for updates every time the app loads
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          if (!newWorker) return
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available — could show a toast here in future
              console.log('[KaiLux] New version available. Refresh to update.')
            }
          })
        })
      })
      .catch((err) => {
        // SW registration failing is non-fatal — app still works
        console.warn('[KaiLux] Service worker registration failed (non-fatal):', err)
      })
  })

  // If SW controller changes (new SW activated), reload for clean state
  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true
      window.location.reload()
    }
  })
}

// ── Phase A2: Expose PWA install prompt ──────────────────────────────────────
// The browser fires beforeinstallprompt before showing the native install UI.
// We capture it here so Settings.jsx can trigger it on demand.
window.__pwaInstallPrompt = null

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  window.__pwaInstallPrompt = event
  // Notify any listeners (Settings page listens for this)
  window.dispatchEvent(new CustomEvent('kailux:installprompt', { detail: event }))
})

window.addEventListener('appinstalled', () => {
  window.__pwaInstallPrompt = null
  window.dispatchEvent(new CustomEvent('kailux:appinstalled'))
  console.log('[KaiLux] App installed as PWA.')
})
